const configuredLevel = import.meta.env.VITE_LOG_LEVEL || 'warn';
const levels = { trace: 0, debug: 1, info: 2, warn: 3, error: 4 };

function enabled(level) {
  return levels[level] >= (levels[configuredLevel] ?? levels.warn);
}

export const logger = {
  trace: (message, details) => enabled('trace') && console.debug(`[trace] ${message}`, details),
  debug: (message, details) => enabled('debug') && console.debug(`[debug] ${message}`, details),
  info: (message, details) => enabled('info') && console.info(`[info] ${message}`, details),
  warn: (message, details) => enabled('warn') && console.warn(`[warn] ${message}`, details),
  error: (message, details) => console.error(`[error] ${message}`, details)
};
